import { styled } from '@styles/stitches';

export const Label = styled('label', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: '$secondaryBackground',
  color: '$secondaryFill',
  width: '100%',
  height: 120,
  borderRadius: 5,
  fontSize: 14,
  cursor: 'copy',

  i: {
    color: 'inherit',
    fontWeight: 'normal',
  },

  '&:hover': {
    color: '$primaryFill',
  },

  variants: {
    hover: {
      true: {
        border: '1px solid $colors$primaryFill',
      },
    },
  },
});

export const Subtext = styled('div', {
  paddingTop: '$space$4',
  fontSize: 12,
  color: '$primaryFill',
});

export const Input = styled('input', {});
